<template>
    <div>
        <mu-row>
            <mu-col span="12">
                <picture>
                    <source type='image/webp' :srcset="`/images/travel_services/${image}.webp`">
                    <img :src="`/images/travel_services/${image}.jpg`" :alt="`${service}`" width='100%'>
                </picture>
            </mu-col>
        </mu-row>
    </div>
</template>

<script>
export default {
    name: 'ImageService',
    props:{
        image: {
            type: String,
            required: true
        },
        service: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // Add your component data here
        };
    },
    methods: {
        // Add your component methods here
    },
};
</script>

<style scoped>
.image-service {
    /* Add your component styles here */
}
</style>